import { createMuiTheme } from "@material-ui/core/styles";


export default createMuiTheme({
    palette: {
        primary: {
            main: '#14a5b2',
            contrastText: '#ffffff'
        },
        secondary: {
            main: '#b22a3e'
        },
    },
    typography: {
        h6: {
            fontSize: "1.05rem"
        }
    }
});
